import type { EstadoDeCarga } from "./hooks/use-dashboard-metrics";

/**
 * Lo que todo widget del panel recibe además de su layout.
 *
 * Los cuatro campos van juntos a propósito: sin `estado` y `nuncaCalculado`, un widget no puede
 * distinguir "no hay datos" de "todavía no se calcularon" de "falló la carga", y los dibuja los tres
 * como un cero. Ver `widget-state/`.
 */
export interface WidgetDataProps<T> {
  data?: T;
  estado: EstadoDeCarga;
  error: string | null;
  nuncaCalculado?: boolean;
  recargar: () => void;
}

/** Los códigos del backend a la etiqueta que el panel viene mostrando. */
export const ETIQUETA_ETAPA: Record<string, string> = {
  store: "Store",
  customer: "Cliente",
  follow: "Seguimiento",
  buy_on: "Comprado On",
  bought_assisted: "Comprado asistido",
  buy_off: "Comprado Off",
};

/** El orden del funnel, de arriba hacia abajo. */
export const ORDEN_ETAPAS = [
  "store",
  "customer",
  "follow",
  "buy_on",
  "bought_assisted",
  "buy_off",
];
